/** Публичная конфигурация сборки (без секретов). Название бренда меняется через VITE_APP_NAME. */
export const config = {
  appName: import.meta.env.VITE_APP_NAME || 'Qaraqalpaq Market',
  apiUrl: (import.meta.env.VITE_API_URL || '').replace(/\/$/, ''),
  botUsername: import.meta.env.VITE_BOT_USERNAME || '',
  miniAppShortName: import.meta.env.VITE_MINIAPP_SHORT_NAME || '',
  devAuth: import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH === 'true',
  devTelegramId: import.meta.env.VITE_DEV_TELEGRAM_ID || '9000000000001',
};
